export const adoptLightStyles = (element: HTMLElement) => {
  const global = window
  const supportsAdoptingStyleSheets =
    global.ShadowRoot &&
    (global.ShadyCSS === undefined || global.ShadyCSS.nativeShadow) &&
    'adoptedStyleSheets' in Document.prototype &&
    'replace' in CSSStyleSheet.prototype

  const rawStyles = (element.constructor as any).styles
  // Lit's `static styles` may be a single CSSResult or an array of them.
  const styles = Array.isArray(rawStyles)
    ? rawStyles
    : rawStyles
      ? [rawStyles]
      : []
  const cssText = styles.map((s: any) => s.cssText).join('\n')

  if (supportsAdoptingStyleSheets) {
    const myStyleSheet = new CSSStyleSheet()
    myStyleSheet.replace(cssText)
    document.adoptedStyleSheets = [...document.adoptedStyleSheets, myStyleSheet]
  } else {
    styles.forEach((s: any) => {
      const style = document.createElement('style')
      const nonce = (global as any)['litNonce']
      if (nonce !== undefined) {
        style.setAttribute('nonce', nonce)
      }
      style.textContent = s.cssText
      document.head.appendChild(style)
    })
  }
}
